/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useEffect, useState } from "react";
//#endregion
//#region Styles
import { Content } from "../../../components/CampusListView/styles";
import { Container } from "../../../styles";
//#endregion
//#region Components
import HeaderComponent from "../components/HeaderComponent";
import SpaceOptionList from "./components/SpaceOptionList/SpaceOptionList";
//#endregion
//#region Services
import { requestGetSpacesByCampus } from "services/settings/spaceAdmin/aboutSpaceAdmin";
import { configSessionStorage } from "services/storage/config";
import { useNavigate } from "react-router-dom";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import BackToView from "components/BackToView/BackToView";
import useDashboardContext from "routes/utils/context/useDashboardContext";
import BackToSettingsView from "../components/BackToSettingsView";
//#endregion

const SpaceListByCampusView = ({
    spaceTypeList,
    loadingRequest
}) => {
    const { userCampusId } = useDashboardContext();
    //#region States
    const [campusName, setCampusName] = useState("");
    const [spaceList, setSpaceList] = useState([]);
    //#endregion
    const navigate = useNavigate();
    //#region Effects
    useEffect(() => {
        const campus = getCampusFromSessionStorage();
        if (!campus) return;
        setCampusName(campus.name);
        fillSpaceList(campus.id);
    }, []);
    //#endregion
    //#region Functions
    const getCampusFromSessionStorage = () => {
        const campus = configSessionStorage.spaceAdmin.campus.get();
        if (!campus?.id) {
            navigate(ABSOLUTE_PATHS.SETTINGS_SPACE_ADMIN);
            return null;
        }
        return campus;
    }
    const fillSpaceList = async campusId => {
        loadingRequest.show();
        const newSpaceList = await requestGetSpacesByCampus(campusId);
        setSpaceList(newSpaceList);
        loadingRequest.hide();
    }
    //#endregion
    return (
        <>
            {userCampusId 
            ? <BackToSettingsView/> 
            : <BackToView to={ABSOLUTE_PATHS.SETTINGS_SPACE_ADMIN} text="Volver al Listado de Campus" />}
            <Container>
                <HeaderComponent spaceTypeList={spaceTypeList}/>
                <Content>
                    <SpaceOptionList
                        campusName={campusName} 
                        spaceList={spaceList}/>
                </Content>
            </Container>
        </>
    );
}

export default SpaceListByCampusView;